// ============================================================
// 📈 TradingViewWidget.jsx — Lightweight embedded chart widget
// ============================================================

import React, { useEffect, useRef } from "react";

const TradingViewWidget = ({ symbol = "EURUSD" }) => {
  const container = useRef();

  useEffect(() => {
    if (!container.current) return;

    // 🔹 Clear any previous widget (fix hot reload / re-render issues)
    container.current.innerHTML = "";

    // 🔹 Detect current theme from the HTML root element
    const isDarkMode = document.documentElement.classList.contains('dark');

    // 🔹 Create TradingView embed script
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbol: symbol,
      width: "100%",
      height: "100%",
      locale: "en",
      dateRange: "12M",
      // ✅ Set theme based on app state
      colorTheme: isDarkMode ? "dark" : "light",
      // ✅ Adjust colors for better visibility in light mode
      trendLineColor: isDarkMode ? "#37a6ef" : "#2563eb", // Brighter blue for light mode
      underLineColor: isDarkMode ? "#2a2e39" : "#e5e7eb", // Light gray underline for light mode
      isTransparent: true,
      autosize: true,
    });

    // ⏱ Add a small delay to ensure DOM is ready before appending
    const timer = setTimeout(() => {
      if (container.current) {
        container.current.appendChild(script);
      }
    }, 50);

    // 🔹 Cleanup timer when unmounting or symbol changes
    return () => clearTimeout(timer);
  }, [symbol]);

  return (
    <div
      className="tradingview-widget-container"
      style={{ height: "100%", width: "100%" }}
      ref={container}
    >
      <div className="tradingview-widget-container__widget" />
    </div>
  );
};

export default TradingViewWidget;